import { useCallback, useState } from 'react';

const CHAR_REGEX = /^[a-zA-Z0-9-_ ]{1}$/;

export function useKeyboardFilter() {
  const [search, setSearch] = useState('');

  const onKey = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Backspace') {
      setSearch(search => search.substring(0, Math.max(0, search.length - 1)));
      e.stopImmediatePropagation();
      e.preventDefault();
    } else if (CHAR_REGEX.test(e.key)) {
      setSearch(search => search + e.key);
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, []);

  return [search, setSearch, onKey] as const;
}
